import { Container } from "./container";
import { Logo } from "./logo";
import { Menu } from "./menu";

export function Header() {
  return (
    <div className="sticky top-0 w-full h-[195px] bg-white pb-[20px] z-1000">
      <Container className="mt-[70px]">
        <div className="flex mb-[50px]">
          <div className="grow flex justify-center">
            <Logo />
          </div>
        </div>
        <div className="mx-auto max-w-screen-md">
          <Menu />
        </div>
      </Container>
    </div>
  );
}
